export default __webpack_public_path__ + "static/5-429cb28849a65d64198f1223454b49a4.png";